<app-header backgroundImage="assets/header/news.webp"
            i18n-title title="News"
            i18n-description description="Alle wichtigen Neuigkeiten rund um Apps, IT-Lösungen und Consulting"/>

<main>
  <div class="d-flex justify-content-end mx-5 mb-2 mt-4">
    @if (!isDetail()) {
      <a [href]="rssUrl" class="h3 rss-link"><span class="bi bi-rss"></span></a>
    }
  </div>

  @if (filter(); as filterParams) {
    <section class="filters">
      <div class="card card-padding shear">
        <div class="shear-inner inner-content">
          <span i18n>Filtern nach:</span>
          <span class="badge text-bg-secondary mx-2 px-2 py-3">
          @switch (filterParams.key) {
            @case ('author') {
              <span class="fw-bold" i18n>Autor:</span>
            }
            @case ('tag') {
              <span class="fw-bold" i18n>Tag:</span>
            }
          }
            <span class="ms-1">{{ filterParams.value.display }}</span>
          <button type="button" class="btn p-0" (click)="resetFilter()"><i class="bi bi-x-circle ms-2"></i></button>
      </span>
        </div>
      </div>
    </section>
  }

  <section class="news">
    @if (newsList(); as news) {
      @for (entry of news.entries; track entry.id) {
        <div class="card card-padding shear">
          <app-news-shear [newsEntry]="entry" [isDetail]="false" (filterChange)="setFilter($event, false)"/>
        </div>
      }
      @if (news.total > news.entries.length) {
        <div class="card card-padding shear my-2 my-md-3 my-lg-4">
          <div class="shear-inner inner-content text-center">
            <a href="javascript:void(0)" (click)="loadMore(news.entries.length)" class="filter" i18n>Mehr laden&hellip;</a>
          </div>
        </div>
      }
    } @else if (newsEntry(); as entry) {
      <div class="card card-padding shear">
        <app-news-shear [newsEntry]="entry" [isDetail]="true" (filterChange)="setFilter($event, true)"/>
      </div>
    }
  </section>
</main>
